<template lang="pug">
    div
        TransformerPartsSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'de'")
    
            div.title-container
                h1.product-title Dielektrisches Fenster Set 
                h2.product-subtitle Ölbarriere für UHF-Fenstersensoren 
    
            div.image-and-highlights-container
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/dielectric_window_set.webp')
                            img( src='@/assets/photos/product_shots/dielectric_window_set.png', width="100%", alt='Dielectric Window', title='Dielectric Window')   
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Für ölgefüllte Transformatoren
                                li Ölbarriere für UHF-Fenstersensoren zur Messung von Teilentladungen (TE) 
                                li Hergestellt aus PEEK: Hochleistungspolymer mit exzellenter mechanischer und chemischer Beständigkeit bis zu hohen Temperaturen 
                                li Entwickelt für die Montage in der Kesselwand von Transformatoren mit unserem 
                                    a.backlink(href='/de/products/transformerparts/welding-ring-set') Anschweißflansch
                                li Geeignet für unseren 
                                    a.backlink(href='/de/products/uhfsensors/uhf-ps1') UHF-PS1 Teilentladungssensor
                                li Kompatibel mit mineralischen, biologischen und synthetischen Transformatorölen 
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet Dielectric Window.pdf")
                            Maillink(to='support@bss-hs.de', sub='Dielectric Window', text='Kontakt', size=30, strokeWidth=2)
                            //Sitelink(to="/de/products/pdm-600", text='UHF-TE-Monitoringsystem PDM-600')
                            Sitelink(to="/de/products/uhfsensors/uhf-ps1", text='TE-Sensor UHF-PS1')
                            Sitelink(to="/de/products/transformerparts/welding-ring-set", text='Anschweißflansch Set')
    
            section
                p Das dielektrische Fenster dient als Ölsperre für UHF-Fenstersensoren wie den 
                    a.backlink(href='/de/products/uhfsensors/uhf-ps1') UHF-PS1.
                    |  Hergestellt aus PEEK, einem Hochleistungspolymer, zeichnet es sich durch hervorragende mechanische und chemische Beständigkeit bei hohen Temperaturen in mineralischen, biologischen und synthetischen Transformatorölen aus. 
                p Das dielektrische Fenster ist dafür konzipiert, an unserem 
                    a.backlink(href='/de/products/transformerparts/welding-ring-set') Anschweißflansch 
                    | montiert zu werden, der in die Transformatorkesselwand integriert wird. Diese Lösung garantiert die Öl- und Vakuumdichtigkeit des Transformators und ermöglicht die nachträgliche Installation von UHF-Fenstersensoren. Dadurch bietet sich maximale Flexibilität bei der Nachrüstung von TE-Monitoringsystemen wie dem 
                    a.backlink(href='/de/products/pdm-600') PDM-600.
                p Das dielektrische Fenster wurde gemäß Cigré TB 662 (Guidelines for partial discharge detection using conventional and unconventional methods) konstruiert. Darüber hinaus empfiehlt Cigré TB 343 (Recommendations for condition monitoring and condition assessment facilities for transformers) neue Transformatoren mit DN50-Ventilen oder dielektrischen Fenstern auszustatten, um die nahtlose Integration von UHF-Sensoren zu einem späteren Zeitpunkt zu ermöglichen.
                p Im Lieferumfang enthalten sind das dielektrische Fenster, ein FPM-Dichtungsring und Edelstahlschrauben für die sichere Befestigung. 
        
        div.fullwidth(v-if="$route.params.lang == 'en'")
    
            div.title-container
                h1.product-title Dielectric Window Set
                h2.product-subtitle Oil Barrier for Window-Type Partial Discharge (PD) Sensors
    
            div.image-and-highlights-container
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/dielectric_window_set.webp')
                            img( src='@/assets/photos/product_shots/dielectric_window_set.png', width="100%", alt='Dielectric Window', title='Dielectric Window')   
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li For oil-filled transformers
                                li Oil barrier for window-type PD sensors
                                li Made from PEEK: High-performance polymer with excellent mechanical and chemical resistance up to high temperatures
                                li Designed to be mounted onto our 
                                    a.backlink(href='/en/products/transformerparts/welding-ring-set') Welding Ring, 
                                    | installed in the transformer tank wall
                                li Suitable for our 
                                    a.backlink(href='/en/products/uhfsensors/uhf-ps1') UHF-PS1 PD sensor
                                li Compatible with mineral, bio-based, and synthetic transformer oils 
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet Dielectric Window.pdf")
                            Maillink(to='support@bss-hs.de', sub='Dielectric Window', text='Contact Us', size=30, strokeWidth=2)
                            //Sitelink(to="/en/products/pdm-600", text='UHF PD Monitoring System PDM-600')
                            Sitelink(to="/de/products/uhfsensors/uhf-ps1", text='PD Sensor UHF-PS1')
                            Sitelink(to="/en/products/transformerparts/welding-ring-set", text='Welding Ring Set')
    
            section
                p The Dielectric Window acts as an oil barrier for window-type UHF partial discharge (pd) sensors such as the 
                    a.backlink(href='/en/products/uhfsensors/uhf-ps1') UHF-PS1.
                    |  It is made from PEEK, a high-performance polymer with excellent mechanical and chemical resistance up to high temperatures in mineral, bio-based, and synthetic transformer oils. 
                p The Dielectric Window is specifically engineered to be mounted onto our 
                    a.backlink(href='/en/products/transformerparts/welding-ring-set') Welding Ring
                    | , installed in the tank wall of a power transformer. This solution guarantees the oil-tight, vacuum capable integrity of the transformer and allows for the later installation of window-type UHF partial discharge sensors in power transformers, offering flexibility in future installments of partial discharge monitoring systems such as the 
                    a.backlink(href='/en/products/pdm-600') PDM-600
                    | .
                p The Dielectric Window is designed according to Cigré TB 662 (Guidelines for partial discharge detection using conventional and unconventional methods). Cigré TB 343 (Recommendations for condition monitoring and condition assessment facilities for transformers) recommends to install DN50 valves or dielectric windows in new transformers to facilitate seamless integration of UHF sensors at a later stage.
                p The Dielectric Window Set consists of the Dielectric Window, stainless steel screws and FPM sealing ring for mounting.
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Dielectric Window Set",
            description:
                "Ölbarriere für UHF Fenstersensoren, hergestellt aus Hochleistungspolymer PEEK.",
        },
        en: {
            title: "BSS | Dielectric Window Set",
            description:
                "Oil barrier for window-type UHF partial discharge sensors, made from high-performance polymer PEEK.",
        },
    },
};
</script>

<style lang='sass' scoped>
    .backlink
        color: $color2
        text-decoration: none
        font-weight: bold
</style>